import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Home from "./pages/Home/Home";

import "./styles/global.css";
import Footer from "./components/Footer/Footer";
import FreeAuditPage from "./pages/FreeAudit/FreeAudit";
import ServicesPage from "./pages/Services/Services";
import ProductsPage from "./pages/Products/Products";
import IndustriesPage from "./pages/Industries/Industries";
import Contacts from "./components/Contacts/Contacts";
import SendGuideForm from "./pages/SendGuide/SendGuide";
import NewsletterPage from "./pages/Newsletter/Newsletter";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions/TermsAndConditions";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/industries" element={<IndustriesPage />} />
        <Route path="/freeaudit" element={<FreeAuditPage />} />
        <Route path="/sendguide" element={<SendGuideForm />} />
        <Route path="/newsletter" element={<NewsletterPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

        {/* Add more routes here */}
      </Routes>
      <Contacts />
      <Footer />
    </Router>
  );
}

export default App;
